// extracted by mini-css-extract-plugin
module.exports = {"quote_container":"styles_quote_container__eymKO","quote_left":"styles_quote_left__yw9e_","quote_right":"styles_quote_right__9VBgX"};